export default __webpack_public_path__ + "static/media/List.cb034787.svg";